export default type => {
  switch (type) {
    case 'magazine':
      return 'Revistas'
    case 'book':
      return 'Livros'
    case 'video':
      return 'Vídeos'
    case 'mixed':
      return 'Mista'
    default:
      return type
  }
}
